'use strict';

module.exports = function () {
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/computed/storage.js
// module id = 1284
// module chunks = 0